import Vue from 'vue'
import App from './App.vue'
import router from './router'
import concrete from '../src/services/jaxrs/concrete'
Vue.config.productionTip = false
// import { Message } from 'element-ui'
//移动端rem适配文件
import './rem.js'
//引入axios
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true
axios.defaults.baseURL = '/' // api 即上面 vue.config.js 中配置的地址
//这个是在发送post请求时设置的头，因为axios和ajax发送的头不一样，这样设置就可以了,其次还要引入Qs，局部引入
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

concrete.configure({
  root: '/app',
  onError: function (code, msg) {
    switch (code) {
      case 101104:
        localStorage.removeItem('ms_username')
        router.push('/login')
        break
      case 1012: // router.go()
        break
      case 1005:
        localStorage.removeItem('ms_username')
        router.push('/login')
        break
      default:
        console.log(msg)
      // Message.error(msg) // alert(msg); // console.log(code+""+msg)
    }
  },
  pollingTimeout: 10,
  globalTokenKey: '123',
  onBroadcast: function (msgId, host, subject, data) {
    console.log(['msgId: ', msgId, '; host: ', host, '; subject: ', subject, '; data: ', data].join(''))
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
